import React from 'react';
import { arrayOf, bool, object, shape, string } from 'prop-types';

import ArrowRight from '@/assets/Icon/svg/ArrowRight';
import BreadcrumbItem from './BreadcrumbItem';
import BreadcrumbSeparator from './BreadcrumbSeparator';
import { styBreadcrumbList, styBreadcrumbActive, styBreadcrumbLink } from './style';

/**
 * BreadCrumb component.
 * @example
 * const breadCrumbLabel =[
 *  {
 *    to: '/',
 *    label: home,
 *    isActive: false
 *  },
 *  {
 *    to: '/child',
 *    label: child 1,
 *    isActive: true,
 *  }
 * ]
 * <BreadCrumb data={breadcrumbLabel} />
 */

const toBreadcrumbItem = (child, index) => (
  <BreadcrumbItem key={`breadcrumb_item${index}`}>{child}</BreadcrumbItem>
);

const withSeparator = (lastIndex) => (acc, child, index) => {
  const notLast = index < lastIndex;
  if (notLast) {
    acc.push([
      child,
      <BreadcrumbSeparator key={`breadcrumb_sep${index}`}>
        <ArrowRight />
      </BreadcrumbSeparator>,
    ]);
  } else {
    acc.push(child);
  }
  return acc;
};

function Breadcrumb({ data, style }) {
  let dataBreadcrumb = data.map(({ to, label, isActive, ...linkProps }) => (
    <a
      key={to}
      href={to}
      className={isActive ? styBreadcrumbActive : styBreadcrumbLink}
      {...linkProps}
    >
      {label}
    </a>
  ));

  const totalItems = dataBreadcrumb.length;
  const lastIndex = totalItems - 1;

  dataBreadcrumb = dataBreadcrumb.map(toBreadcrumbItem).reduce(withSeparator(lastIndex), []);

  return (
    <ol className={styBreadcrumbList} style={style}>
      {dataBreadcrumb}
    </ol>
  );
}

Breadcrumb.propTypes = {
  data: arrayOf(
    shape({
      to: string,
      label: string,
      isActive: bool,
    })
  ),
  style: object,
};

Breadcrumb.defaultProps = {
  data: [],
  style: {},
};

export default Breadcrumb;
